import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { RenderContext } from "../../contexts/RenderContext";
import { ScrollBar } from "../../Theme/Hyper";
const TableHeader = styled.div`
  display: flex;
  font-weight: 100;
  background-color: #252e40;

  div {
    padding: 0.5em;
    border-left: 1px solid black;
    font-size: 0.8em;
    :first-child {
      width: 40px;
      display: flex;
      justify-content: center;
    }
    :nth-child(2) {
      width: 60px;
      display: flex;
    }
    :nth-child(3) {
      width: 320px;
      display: flex;
    }
    :nth-child(4) {
      width: 80px;
      display: flex;
    }
  }
`;
const TableBody = styled.div`
  display: flex;
  flex-direction: column;
`;
const TableRow = styled.div`
  display: flex;
  align-items: center;
  height: 25px;
  white-space: pre;

  :nth-of-type(even) {
    background-color: #1c222b;
  }
  :hover {
    background-color: #d11e42;
  }
  div {
    height: 25px;
    padding: 0.5em;
    padding-left: 10px;
    border-left: 1px solid black;
    font-size: 0.7em;
    align-items: center;
    display: flex;
  }
`;

const Name = styled.div`
  flex-grow: 1;
  overflow-x: hidden;
`;
const Status = styled.div`
  min-width: 80px;
`;
const ID = styled.div`
  min-width: 40px;
`;
const Main = styled(ScrollBar)`
  max-height: 90vh;
  overflow-y: auto;
`;

const Popup = styled.div`
  background-color: ${(props) => props.theme.panelColour};
  border-radius: 4px;
  width: 200px;
  box-shadow: 0px 4px 12px -20px rgba(0, 0, 0, 0.2),
    0px 8px 20px 2px rgba(0, 0, 0, 0.14), 0 9px 46px 8px rgba(0, 0, 0, 0.12);
  font-size: 0.8em;
  overflow: hidden;
`;

const PopupItem = styled.div`
  padding: 0.5em;
  :hover {
    background-color: #d11e42;
  }
  /* border-bottom: 1px solid grey; */
`;
const PopupGroup = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid black;
`;
function RenderQueue() {
  const { renderQueue, activeRenderQueue, getRenderQueueData } =
    useContext(RenderContext);
  const [contextMenuItem, setContextMenuItem] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  function deleteJob({ id }) {
    fetch(
      "https://stage-render-queue.hyper.live/admin/queues/api/queues/" +
        window.render_queue +
        "/" +
        id +
        "/clean",
      { method: "PUT" }
    ).then(() => {
      getRenderQueueData();
    });
  }
  function handleContextMenu(e, item) {
    setContextMenuItem({
      item: item,
      mouseX: e.clientX,
      mouseY: e.clientY,
      showContext: true,
    });

    e.preventDefault();
    window.addEventListener("click", handleClick);
  }

  function handleClick() {
    setContextMenuItem({
      ...contextMenuItem,
      showContext: false,
    });
    window.removeEventListener("click", handleClick);
  }
  return (
    <Main>
      <TableBody>
        {activeRenderQueue?.jobs?.map((job) => {
          return (
            <TableRow onClick={() => {}}>
              <ID></ID>
              <ID>{job?.id}</ID>
              <Name>{job?.data?.filename}</Name>
              <Status>Rendering</Status>
            </TableRow>
          );
        })}
        {renderQueue?.jobs
          ?.sort((a, b) => {
            return a.id - b.id;
          })
          ?.map((job, index) => {
            return (
              <TableRow
                onContextMenu={(e) => {
                  handleContextMenu(e, job);
                }}
              >
                <ID>#{index + 1}</ID>
                <ID>{job?.id}</ID>
                <Name>{job?.data?.filename}</Name>
                <Status>Waiting</Status>
              </TableRow>
            );
          })}
      </TableBody>
      {contextMenuItem && contextMenuItem.showContext && (
        <Popup
          style={{
            position: "absolute",
            left: contextMenuItem.mouseX + 10,
            top: contextMenuItem.mouseY,
          }}
        >
          <PopupGroup>
            <PopupItem
              onClick={() => {
                debugger;
                deleteJob({ id: contextMenuItem.item?.id });
                setShowPopup(true);
              }}
            >
              Delete
            </PopupItem>
          </PopupGroup>
        </Popup>
      )}
    </Main>
  );
}

export default RenderQueue;
